import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { useAppDispatch, RootState } from "./store";
import { refreshAccessToken, getUser } from "./auth/authSlice";
import { router } from "./router";
import OfflineNotification from "./components/offline";

const App = () => {
  const dispatch = useAppDispatch();
  const accessToken = localStorage.getItem("accessToken");
  const refreshToken = localStorage.getItem("refreshToken");
  const { loading, user } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (!accessToken && refreshToken && !loading) {
      dispatch(refreshAccessToken());
    }
  }, [accessToken, refreshToken, loading, dispatch]);

  useEffect(() => {
    if (accessToken && !user && !loading) {
      dispatch(getUser());
    }
  }, [accessToken, user, loading, dispatch]);

  return (
    <>
      <OfflineNotification />
      <RouterProvider router={router} />
    </>
  );
};

export default App;
